export default "__VITE_ASSET__BuV6Tf9n__"